import { getAppConfig } from '../config/appConfigRef';

export function getStoredRefreshToken(): string | null {
  return localStorage.getItem(getAppConfig().refreshTokenKey);
}

export function setStoredRefreshToken(token: string): void {
  localStorage.setItem(getAppConfig().refreshTokenKey, token);
}

export function removeStoredRefreshToken(): void {
  localStorage.removeItem(getAppConfig().refreshTokenKey);
}
